import React from 'react';

import { FormattedMessage } from 'react-intl';
import { call, put } from 'redux-saga/effects';

import { fetchFilesListSaga } from '@sagas/filing/files/fetchFilesListSaga';
import { toastError } from '@store/notifications';

export const handleFetchFilesListSaga = function* () {
  try {
    yield call(fetchFilesListSaga);
  } catch (errors) {
    const { nonFieldErrors } = errors.data || {};

    yield put(
      toastError({
        message: nonFieldErrors || (
          <FormattedMessage
            defaultMessage="An unexpected error occurred, please try again."
            id="global.notification.api-error-default"
          />
        ),
      })
    );
  }
};
